/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "pay-visa-5f9b7d2b--sprite",
  "use": "pay-visa-5f9b7d2b--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"pay-visa-5f9b7d2b--sprite\"><g transform=\"translate(-81.166 -93.044)\"><path d=\"M436.423,122.005h-2.916l1.824-11.279h2.916Z\" transform=\"translate(-339.658 -5.475)\" fill=\"#00579f\" /><path d=\"M573.927,105.528a7.186,7.186,0,0,0-2.616-.48c-2.88,0-4.908,1.536-4.92,3.731-.024,1.62,1.452,2.52,2.556,3.06,1.128.552,1.512.912,1.512,1.4-.011.756-.912,1.1-1.751,1.1a5.8,5.8,0,0,1-2.736-.6l-.384-.18-.408,2.532a8.875,8.875,0,0,0,3.252.6c3.06,0,5.052-1.512,5.076-3.852.012-1.284-.768-2.268-2.448-3.072-1.02-.516-1.645-.864-1.645-1.392.012-.48.528-.972,1.68-.972a4.955,4.955,0,0,1,2.172.432l.264.12.4-2.435Z\" transform=\"translate(-466.589 0)\" fill=\"#00579f\" /><path d=\"M795.034,118.01c.24-.648,1.164-3.156,1.164-3.156-.012.024.24-.66.384-1.08l.2.972s.552,2.7.672,3.264Zm3.6-7.283h-2.256a1.439,1.439,0,0,0-1.524.936l-4.332,10.343h3.06l.612-1.692h3.744c.084.4.348,1.692.348,1.692h2.7l-2.353-11.278Z\" transform=\"translate(-683.82 -5.475)\" fill=\"#00579f\" /><path d=\"M173.036,110.727l-2.856,7.691-.312-1.56a8.633,8.633,0,0,0-4.032-4.728l2.616,9.863h3.084l4.584-11.267Z\" transform=\"translate(-81.622 -5.475)\" fill=\"#00579f\" /><path d=\"M85.906,110.727H81.214l-.048.228a9.758,9.758,0,0,1,7.08,5.9l-1.02-5.184a1.207,1.207,0,0,0-1.32-.948Z\" transform=\"translate(0 -5.475)\" fill=\"#faa61a\" /></g><rect width=\"36\" height=\"36\" transform=\"translate(0)\" fill=\"none\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
